import {
  VERBIS_LEBENSLAUF_MAX_BYTES_GESAMT,
  VERBIS_LEBENSLAUF_MAX_BYTES_PRO_DATEI,
  VERBIS_LEBENSLAUF_MAX_DATEIEN,
} from '../../api/verbisLebenslauf'

export const KEINE_DATEI_TEXT = "Bitte mindestens eine Datei auswählen."

export function keinBildText(file: File): string {
  return `„${file.name}“ ist kein PNG- oder JPG-Bild.`
}

export function hinzufuegenFehler(vorhanden: readonly File[], neu: readonly File[]): string | null {
  const alle = [...vorhanden, ...neu]
  if (alle.length > VERBIS_LEBENSLAUF_MAX_DATEIEN) {
    return `Höchstens ${VERBIS_LEBENSLAUF_MAX_DATEIEN} Screenshots auf einmal – Sie haben ${alle.length} ausgewählt.`
  }
  const gesamt = alle.reduce((sum, file) => sum + file.size, 0)
  if (neu.some((file) => file.size > VERBIS_LEBENSLAUF_MAX_BYTES_PRO_DATEI) || gesamt > VERBIS_LEBENSLAUF_MAX_BYTES_GESAMT) {
    return "Die Dateien sind zu groß (höchstens 10 MB pro Bild, 30 MB zusammen)."
  }
  return null
}
